/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleFixedTiered extends models.BillingRuleCalculate {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleFixedTiered");
    }

    getFixupPrototypeFunction() { return BillingRuleFixedTiered.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleFixedTiered>): BillingRuleFixedTiered {
        let obj = Object.assign(new BillingRuleFixedTiered(), model);
        BillingRuleFixedTiered.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleFixedTiered>): BillingRuleFixedTiered {
        if (!model) return null;
        return BillingRuleFixedTiered.newInstance(<BillingRuleFixedTiered> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleFixedTiered) {
        if (!obj) return;

        models.BillingRuleFixedTiered.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleFixedTiered): boolean {
        if (models.BillingRuleCalculate.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleFixedTiered.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tiers) {
            for (let val of this.tiers) {
                models.BillingRuleTier.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tiers
     */
    tiers: Array<models.BillingRuleTier>;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
